import { render } from "./ListsContacts.vue?vue&type=template&id=1a85e586&scoped=true"
import script from "./ListsContacts.vue?vue&type=script&lang=ts"
export * from "./ListsContacts.vue?vue&type=script&lang=ts"

import "./ListsContacts.vue?vue&type=style&index=0&id=1a85e586&scoped=true&lang=css"
import "./ListsContacts.vue?vue&type=style&index=1&id=1a85e586&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1a85e586"

export default script